import type { Dictionary } from '../i18n.js';

export const lobby: Dictionary = {
  // lobbyScreen.ts
  'Copy link': 'Kopiuj link',
  'The host has not picked a region yet.': 'Gospodarz nie wybrał jeszcze obszaru.',
  'Draw your own': 'Narysuj własny',
  'Your own region': 'Twój własny obszar',
  'Adjust the route': 'Dopasuj trasę',
  'Pick a region first — then you can move its start and finish, turn the grid round or place checkpoints.':
    'Najpierw wybierz obszar — potem przesuniesz start i metę, obrócisz pola startowe albo postawisz punkty kontrolne.',
  'Search tours': 'Szukaj turniejów',
  All: 'Wszystkie',
  Mine: 'Moje',
  'New tour': 'Nowy turniej',
  'Where are we racing?': 'Gdzie się ścigamy?',
  'The host’s pick': 'Wybór gospodarza',
  'Free drive': 'Swobodna jazda',
  'Free drive in {label}.': 'Swobodna jazda: {label}.',
  'Start free drive': 'Rozpocznij swobodną jazdę',
  '{who} picked a free drive in {title}': '{who} wybiera swobodną jazdę: {title}',
  Opponents: 'Przeciwnicy',
  "I'm ready": 'Zgłoś gotowość',
  'Start race': 'Rozpocznij wyścig',
  'Stop building': 'Przerwij budowanie',
  Leave: 'Wyjdź',
  'Building the world': 'Budowanie świata',
  'Lobby code': 'Kod lobby',
  'Race control': 'Dyrekcja wyścigu',
  Drivers: 'Kierowcy',
  '{n} races': { one: '{n} wyścig', few: '{n} wyścigi', many: '{n} wyścigów' },
  archived: 'archiwalny',
  'Edit {name}': 'Edytuj {name}',
  'Nothing matches that.': 'Nic nie pasuje do wyszukiwania.',
  'No tours saved yet. Make one and it is there for everybody.':
    'Nie ma jeszcze zapisanych turniejów. Stwórz pierwszy — będzie dostępny dla wszystkich.',
  'Not ready': 'Cofnij gotowość',
  host: 'gospodarz',
  ready: 'w gotowości',
  waiting: 'czeka',
  'Racing the {name}: {stops}.': 'Rozgrywamy „{name}”: {stops}.',
  'a custom region': 'własny obszar',
  'Racing in {label}.': 'Wyścig: {label}.',
  'Pick a region below, then start the race.': 'Wybierz obszar poniżej, a potem rozpocznij wyścig.',
  'Waiting for the host to pick a region.': 'Czekamy, aż gospodarz wybierze obszar.',
  '{area} km² · click to edit': '{area} km² · kliknij, żeby edytować',
  'Building the world…': 'Budowanie świata…',
  'Start the {name}': 'Rozpocznij „{name}”',
  'Start anyway': 'Rozpocznij mimo to',
  'Still connecting to the lobby.': 'Wciąż łączę z lobby.',
  "Only the host can start the race — that is {name}. Press “I'm ready” so they know you are.":
    'Wyścig może rozpocząć tylko gospodarz — to {name}. Naciśnij „Zgłoś gotowość”, żeby dać znać, że możesz jechać.',
  "Only the host can start the race. Press “I'm ready” so they know you are.":
    'Wyścig może rozpocząć tylko gospodarz. Naciśnij „Zgłoś gotowość”, żeby dać znać, że możesz jechać.',
  'The world is already being built — it starts by itself when it is ready.':
    'Świat już się buduje — wyścig ruszy sam, gdy wszystko będzie gotowe.',
  'Pick something to race first: a tour, one of the regions below, or draw your own.':
    'Najpierw wybierz, gdzie się ścigacie: turniej, jeden z obszarów poniżej albo własny, narysowany na mapie.',
  'The host': 'Gospodarz',
  '{who} picked a tour: {name}': '{who} wybiera turniej: {name}',
  '{who} picked {title}': '{who} wybiera: {title}',
  '{who} drew a region on the map': '{who} wybiera obszar narysowany na mapie',
  '{who} has not picked anything yet': '{who} jeszcze się zastanawia',
  'Whatever they choose lights up below.': 'Cokolwiek wybierze, podświetli się poniżej.',
  'No opponents — just the drivers in this lobby.': 'Bez przeciwników — tylko kierowcy z tego lobby.',
  '{opponents} alongside {drivers}.': 'Na starcie: {opponents} i {drivers}.',
  '{n} opponents': { one: '{n} przeciwnik', few: '{n} przeciwników', many: '{n} przeciwników' },
  '{n} drivers': { one: '{n} kierowca', few: '{n} kierowców', many: '{n} kierowców' },
  'Copied!': 'Skopiowano!',
  'Race': 'Wyścig',
  'One region, first to the flag wins': 'Jeden obszar, wygrywa pierwszy na mecie',
  'Tour': 'Turniej',
  'Several races back to back, for points': 'Kilka wyścigów po kolei, o punkty',
  'No gates, no clock — drop in any time': 'Bez bramek i zegara — dołącz kiedy chcesz',
  'Saved in this browser': 'Zapisane w tej przeglądarce',
  'From the tours': 'Z turniejów',
  'Step 1': 'Krok 1',
  'Step 2': 'Krok 2',
  'Built in, or drawn by you': 'Gotowe albo narysowane przez ciebie',
  'Which tour?': 'Który turniej?',
  'What are we doing?': 'Co robimy?',
  'Pick a tour to race the whole cup.': 'Wybierz turniej, żeby rozegrać cały puchar.',
  '{area} km² · drawn here': '{area} km² · narysowany tutaj',
  'Forget {name}': 'Zapomnij: {name}',
  'Drive them all, one after another': 'Przejedź wszystkie, jeden po drugim',
  'Where are we driving?': 'Gdzie jeździmy?',
  'Free drive through the {name}: {stops}.': 'Swobodna jazda przez „{name}”: {stops}.',
  'Move the start': 'Przesuń start',
  'Pick a tour first — or choose Race or Free drive above.': 'Najpierw wybierz turniej — albo wybierz wyżej Wyścig lub Swobodną jazdę.',
  '{who} picked a free drive through a tour: {name}': '{who} wybiera swobodną jazdę przez turniej: {name}',
  '{who} drew a region on the map for a free drive': '{who} rysuje obszar na mapie do swobodnej jazdy',
  'Real, right now': 'Prawdziwa, teraz',
  'Choose': 'Wybierz',
  'Local time': 'Czas lokalny',
  'Weather and time': 'Pogoda i pora dnia',
};
